// extracted by mini-css-extract-plugin
export default {"header":"index_header_7wgQO","tool":"index_tool_3afJe"};